export default __webpack_public_path__ + "78ed33f33ab81a11fa136ced453530e4.png";